import React from "react"
import update from "immutability-helper"
import moment from "moment"
import { connect } from "react-redux"
import { showNotificationWithTimeout } from "../_actions/adminAlertActionCreator"
import Loader from "../common/Loader"
import DialogBox from "../common/DialogBox"
import DirectCheckoutSteps from "./DirectCheckoutSteps"
import NotFound from "../common/NotFound"
import OrderSummary from "./OrderSummary"
import { API, API_PUBLIC } from "../api"
import ShoppingCart from "./ShoppingCart"
import CustomerInfo from "./CustomerInfo"
import ShippingMethod from "./ShippingMethod"
import PaymentMethod from "./PaymentMethod"
import CreateAccountForm from "../customer-account/CustomerAccount"
import CheckForgotPassword from "../customer-account/CheckForgotPassword/CheckForgotPassword"
import CheckoutFooter from "./CheckoutFooter"
import OrderConfirmation from "./OrderConfirmation"
import getShipping from "../common/utils/getShipping"
import isTaxInclusive from "../common/utils/isTaxInclusive"
import PageTitle from "./common/PageTitle"
import AdminAlert from "../Admin/AdminAlert/AdminAlert"
import Cancelled from "./Cancelled"
import "./DirectCheckout.css"
import CancelOrder from "./CancelOrder"
import EmailVerification from "./CustomerInfo/EmailVerification"
import queryString from "query-string"
import OrderForm from "./OrderForm/OrderForm"

const STEPS = ["cart", "info", "shipping", "payment"]

class DirectCheckout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checkoutMethod: null,
      fetching: true,
      orderNotFound: false,
      orderNotCreated: false,
      orderCancelled: null,
      orderData: {},
      products: [],
      customProducts: [],
      customerData: {},
      customerAddress: {},
      customerRemarks: "",
      selectedProduct: {},
      steps: [],
      activeStep: "cart",
      removeDialogShown: false,
      info: { active: "login" },
      coupon: "",
      deliveryData: null,
      pickupAddressList: null,
      paymentMethod: null,
      onlinePaymentDetails: null,
      createAccount: false,
      showRegister: false,
      accountCreated: false,
      confirmingOrder: false,
      confirmError: false,
      forConfirmation: false,
      cancelling: false,
      showForgotPassword: false,
      businessName: "",
      daysLeft: 0,
      canSelectAllCountry: false,
      showVerifyEmail: false,
      verifyEmail: "",
      verifyMobile: "",
      emailVerificationError: false,
      showFacebookErrorPopup: false,
      isNewOrder: false, //This means order is created via the Order Form.
      newOrderAdjustmentId: null,
      customerNewAccount: false,
      customer_id: null,
      account_uuid: null,
      payoAsiaId: null,
      courierPaymentOnly: false,
      showEmailVerificationSuccess: false
    }
  }

  setCustomerStatus = (newAccount, id = null) => {
    if (newAccount) {
      this.setState(state => ({ ...state, customerNewAccount: newAccount }))
    } else {
      this.setState(state => ({
        ...state,
        newAccount: newAccount,
        customer_id: id
      }))
    }
  }

  handleConfirmPaymentMethod = async () => {
    const { createAccount } = this.state
    if (createAccount) {
      this.showAccountRegister()
    } else {
      this.confirmOrder()
    }
  }

  showAccountRegister = () => {
    this.setState({ showRegister: true })
  }

  createAccountCallback = (customerData = null) => {
    const { createAccount } = this.state
    this.setState(
      state => ({
        ...state,
        accountCreated: true,
        showRegister: false,
        customer_id: (customerData && customerData.id) || state.customer_id
      }),
      () => {
        if (createAccount) {
          this.confirmOrder()
        } else {
          this.setState({ showRegister: false, createAccount: false })
        }
      }
    )
  }

  createAccountCancel = () => {
    this.setState({ showRegister: false, createAccount: false })
  }

  handleForgotPassword = () => {
    this.setState({ showForgotPassword: true })
  }

  hideForgotPassword = () => {
    this.setState({ showForgotPassword: false })
  }

  handleShowVerifyEmail = (email, mobile) => {
    this.setState({
      showVerifyEmail: true,
      verifyEmail: email,
      verifyMobile: mobile
    })
  }

  hideVerifyEmail = () => {
    this.setState({ showVerifyEmail: false })
  }

  isVerifyingEmail = async () => {
    const { location } = this.props
    const params = queryString.parse(location.search)
    return params && params["token"]
  }

  verifyEmail = async (token, uuid, mobile) => {
    if (this.isVerifyingEmail()) {
      API.defaults.headers.common["x-access-token"] = token
      try {
        const res = await API.put(`customers/${uuid}/verify_email`, {
          mobile: `${mobile.countryCode}${mobile.mobileNumber}`
        })
        if (res.status === 200) {
          this.setActiveStep("info")
          this.chooseLogin("email")
        }
      } catch (err) {
        if (
          err.response.data &&
          err.response.data.message === "EMAIL_IS_VERIFIED!"
        ) {
          this.setActiveStep("info")
          this.chooseLogin("email")
        }
      }
    }
  }

  confirmOrder = async (shouldRefresh = true, shouldTrimRemarks = false) => {
    //Do not proceed if customer remarks exceeds 250 chars
    const {
      // deliveryData,
      customerRemarks,
      isNewOrder
    } = this.state
    let newCustomerRemarks = customerRemarks
    if (customerRemarks && customerRemarks.length > 250) {
      if (shouldTrimRemarks) {
        newCustomerRemarks = customerRemarks.substring(0, 250)
      } else {
        return
      }
    }
    const { confirmingOrder } = this.state
    if (!confirmingOrder) {
      this.setState({ confirmingOrder: true, fetching: true })
      // if (
      //   deliveryData.method &&
      //   deliveryData.method.value &&
      //   deliveryData.method.value.name &&
      //   deliveryData.method.value.name.toLowerCase() === "lalamove"
      // ) {
      //   this.getLalamoveRate()
      // }
      try {
        //const response = await API.post()
        const {
          products,
          customProducts,
          deliveryData,
          // customerRemarks,
          paymentMethod,
          customerData,
          customerAddress,
          orderData
        } = this.state
        const productData =
          (products &&
            products.length > 0 &&
            products.map(p => ({ id: p.id, quantity: p.quantity }))) ||
          []
        const customProductData =
          (customProducts &&
            customProducts.length > 0 &&
            customProducts.map(p => p.id)) ||
          []
        const customer =
          (customerData && {
            firstname: customerData.firstName,
            lastname: customerData.lastName,
            email: customerData.email || null,
            mobile_country_code:
              customerData.mobile && customerData.mobile.countryCode,
            mobile: customerData.mobile && customerData.mobile.mobileNumber
          }) ||
          {}
        const shipping =
          //Check if delivery data is not null
          deliveryData &&
          //Check if delivery toMe is set to true
          ((deliveryData.toMe && {
            contact_person:
              //Set contact person to customer data
              (customerData && {
                firstname: customerData.firstName,
                lastname: customerData.lastName,
                email: customerData.email,
                mobile_country_code:
                  customerData.mobile && customerData.mobile.countryCode,
                mobile: customerData.mobile && customerData.mobile.mobileNumber
              }) ||
              {},
            //Set address to customer address
            address:
              (customerAddress && {
                address_line_1: customerAddress.addressOne,
                address_line_2: customerAddress.addressTwo,
                barangay: customerAddress.barangay.value,
                city: customerAddress.city.value || customerAddress.city,
                zipcode: customerAddress.zipcode,
                country: customerAddress.country.value,
                province: customerAddress.state.value
              }) ||
              {},
            location: { place_id: "", latitude: "", longitude: "" }
          }) || {
            //Set contact person to delivery data
            contact_person:
              (deliveryData && {
                firstname: deliveryData.firstName,
                lastname: deliveryData.lastName,
                email: deliveryData.email,
                mobile_country_code:
                  deliveryData.mobile && deliveryData.mobile.countryCode,
                mobile: deliveryData.mobile && deliveryData.mobile.mobileNumber
              }) ||
              {},
            //Set address to delivery data
            address:
              (deliveryData && {
                address_line_1: deliveryData.addressOne,
                address_line_2: deliveryData.addressTwo,
                barangay: deliveryData.barangay.value,
                city: deliveryData.city.value || deliveryData.city,
                zipcode: deliveryData.zipcode,
                country: deliveryData.country.value,
                province: deliveryData.state.value
              }) ||
              {},
            location: { place_id: "", latitude: "", longitude: "" }
          })
        const newOrderData = {
          customer_id: this.state.customer_id || customerData.id || null,
          product: (productData && productData.length > 0 && productData) || [],
          courier_id: (deliveryData && deliveryData.courier_id) || null,
          adjustment_id: this.state.isNewOrder
            ? this.getShippingRateId() || null
            : (deliveryData && deliveryData.adjustment_id) || null,
          is_pickup: (deliveryData && deliveryData.preferPickup) || false,
          pickup_id:
            (deliveryData &&
              deliveryData.preferPickup &&
              parseInt(deliveryData.pickUpAddress)) ||
            null,
          ship_to_me: (deliveryData && deliveryData.toMe) || false,
          customer_remark: newCustomerRemarks || "",
          payment: parseInt(paymentMethod) || null,
          customer: customer,
          shipping: shipping,
          online_payment: this.state.onlinePaymentDetails,
          is_custom_tax: orderData.is_custom_tax,
          custom_product:
            (customProductData &&
              customProductData.length > 0 &&
              customProductData) ||
            [],
          courier: deliveryData.courier || null,
          misc: deliveryData.misc || null,
          delivery:
            (deliveryData.method === "lalamove" &&
              deliveryData.courier &&
              deliveryData.courier.scheduleAt &&
              moment(deliveryData.courier.scheduleAt)
                .local()
                .format("YYYY-MM-DD HH:mm")) ||
            null
        }
        const { location, history } = this.props
        const newOrderUuid = queryString.parse(location.search, {
          ignoreQueryPrefix: true
        }).uid
        API_PUBLIC.defaults.headers.common["account-uuid"] = newOrderUuid
        const response = isNewOrder
          ? await API_PUBLIC.post(`/checkout`, JSON.stringify(newOrderData))
          : await API.put(
              `/checkout/${this.props.match.params.order_uuid}`,
              JSON.stringify(newOrderData)
            )
        this.setState({ confirmingOrder: true })
        if (response.status === 201) {
          if (this.state.isNewOrder) {
            history.push(`/checkout/${response.data.data.order_uuid}`)
          } else {
            this.setState({ confirmingOrder: false })
            shouldRefresh && this.getOrderByUUID()
            return Promise.resolve()
          }
        } else {
          this.setState({ orderNotFound: true })
          this.setState({ confirmingOrder: false })
          return Promise.reject()
        }
      } catch (error) {
        console.log(error.response || error)
        this.setState({ orderNotFound: true })
        this.setState({ confirmingOrder: false })
        return Promise.reject()
      }
    }
  }

  // getLalamoveRate = async () => {
  //   const { deliveryData, orderData } = this.state
  //   const scheduleDate = `${
  //     new Date(new Date().toString().split("GMT")[0] + " UTC")
  //       .toISOString()
  //       .split(".")[0]
  //   }Z`
  //   // let lalamoveObject = {
  //   //   scheduleAt: "2020-03-14T08:09:33Z",
  //   //   serviceType: "MPV",
  //   //   specialRequests: [],
  //   //   requesterContact: {
  //   //       name: "Draco Yam",
  //   //       phone: "09321234567"
  //   //     },
  //   //   stops: [
  //   //       {
  //   //         location: {lat: "14.601896", lng: "120.986711"},
  //   //         addresses: {
  //   //             en_PH: {
  //   //                 displayString: "1958 CM, Recto Ave, Quiapo, Manila, Metro Manila, Philippines",
  //   //                 country: "PH"
  //   //               }
  //   //           }
  //   //       }
  //   //     ],
  //   // deliveries: [
  //   //     {
  //   //       toStop: 1,
  //   //       toContact: {
  //   //           name: "Brian Garcia",
  //   //           phone: "09321234567"
  //   //         },
  //   //       remarks: "ORDER #: 1234, ITEM 1 x 1, ITEM 2 x 2"
  //   //     }
  //   //   ]
  //   // }
  //   if (orderData.courier) {
  //     // will be removed when "courier" object from the order data is present.
  //     let lalamoveObject = orderData.courier
  //     const finalStop = {
  //       location: {
  //         lat: deliveryData.latLng.lat.toString(),
  //         lng: deliveryData.latLng.lng.toString()
  //       },
  //       addresses: {
  //         en_PH: {
  //           displayString: deliveryData.addressString,
  //           country: "PH"
  //         }
  //       }
  //     }
  //     lalamoveObject.specialRequests =
  //       lalamoveObject.serviceType.toLocaleLowerCase() === "motorcycle"
  //         ? ["insulated box"]
  //         : []
  //     lalamoveObject.scheduleAt = scheduleDate
  //     lalamoveObject.stops = [...lalamoveObject.stops, finalStop]

  //     try {
  //       await API.post(
  //         `/checkout/${
  //           this.props.match.params.order_uuid
  //         }/courier/lalamove/get_rate`,
  //         JSON.stringify(lalamoveObject)
  //       )
  //     } catch (error) {
  //       console.log((error.response && error.reponse) || error.res)
  //     }
  //   }
  // }

  backHandler = () => {
    const { activeStep } = this.state
    const currentIndex = STEPS.indexOf(activeStep)
    this.setActiveStep(STEPS[currentIndex - 1])
  }

  setPaymentMethod = async method => {
    if (method !== this.state.paymentMethod) {
      this.setState(
        state => ({ ...state, paymentMethod: method }),
        () => {
          return Promise.resolve()
        }
      )
    } else {
      this.setState(
        state => ({ ...state, paymentMethod: null }),
        () => {
          return Promise.resolve()
        }
      )
    }
  }

  setOnlinePaymentDetails = async (details, code, method) => {
    switch (code) {
      case "PAYP":
        this.setState(
          state => ({
            ...state,
            onlinePaymentDetails: details,
            paymentMethod: method
          }),
          () => {
            this.confirmOrder(true, true)
          }
        )
        break

      case "PAYM":
        this.setState(
          state => ({
            ...state,
            onlinePaymentDetails: details,
            paymentMethod: method
          }),
          async () => {
            //Start for after state
            await this.confirmOrder(false, true)
            const { orderData, products } = this.state
            const { showAlert } = this.props
            const items = products.map(p => ({
              name: p.name,
              code: p.id.toString(),
              description:
                p.variants[0] !== "default_option" ? p.variants.join(" ") : "",
              quantity: p.quantity,
              amount: {
                value: p.price
              },
              totalAmount: {
                value: parseFloat(p.quantity) * parseFloat(p.price)
              }
            }))
            try {
              const customer = orderData.customer_info
              const paymayaBody = {
                totalAmount: {
                  currency: orderData.currency,
                  value: this.getGrandTotal(),
                  details: {
                    shippingFee: this.getShippingRate(),
                    tax: this.getTax(),
                    subTotal: this.getSalesBeforeTax(),
                    discount: this.getDiscount()
                  }
                },
                buyer: {
                  firstName: customer.firstname,
                  middleName: "",
                  lastName: customer.lastname,
                  contact: {
                    phone: customer.mobile_country_code + customer.mobile,
                    email: customer.email
                  },
                  shippingAddress: {},
                  billingAddress: {},
                  ipAddress: ""
                },
                items: items,
                redirectUrl: {
                  success: window.location.href,
                  failure: window.location.href,
                  cancel: window.location.href
                },
                requestReferenceNumber: orderData.uuid,
                metadata: {}
              }
              const response = await API.post(
                `/checkout/${orderData.uuid}/payment/paymaya`,
                JSON.stringify(paymayaBody)
              )
              const { redirectUrl } = response.data
              window.location.href = redirectUrl
            } catch (error) {
              console.log(error.response || error)
              showAlert({
                message:
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  "Error proccesing PayMaya payment.",
                type: "error",
                consumer: "checkout"
              })
            }
            //End for end state
          }
        )
        break

      case "COINS":
        this.setState(
          state => ({
            ...state,
            onlinePaymentDetails: details,
            paymentMethod: method
          }),
          async () => {
            //Start for after state
            await this.confirmOrder(false, true)
            const { orderData } = this.state
            const { showAlert } = this.props
            try {
              const customer = orderData.customer_info
              const coinsBody = {
                payer_contact_info: customer.email,
                message: `Thank you for your Order #${
                  orderData.order_number
                }, ${customer.firstname}!`
              }
              const response = await API.post(
                `/checkout/${orderData.uuid}/payment/coinsph`,
                JSON.stringify(coinsBody)
              )
              const paymentUrl = response.data["payment-request"]["payment_url"]
              window.location.href = paymentUrl
            } catch (error) {
              console.log(error.response || error)
              showAlert({
                message:
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  "Error proccesing Coins.ph payment.",
                type: "error",
                consumer: "checkout"
              })
            }
            //End for end state
          }
        )
        break

      default:
        break
    }

    // try {
    //   const response = await API.put(
    //     `checkout/${this.state.orderData.uuid}/payment`,
    //     JSON.stringify({ online_payment: details })
    //   )
    //   console.log(response)
    //   await this.getOrderByUUID()
    // } catch (error) {
    //   console.log(error.response || error)
    // } finally {
    //   this.setState({ fetching: false })
    // }
  }

  handleCustomerRemarksChange = e => {
    const val = e.target.value
    this.setState({ customerRemarks: val })
  }

  handleCouponChange = e => {
    const val = e.target.value
    this.setState({ coupon: val })
  }

  getSubTotal = () => {
    const subTotal = [
      ...this.state.products,
      ...this.state.customProducts
    ].reduce((a, c) => a + parseInt(c.quantity) * parseFloat(c.price), 0)
    return subTotal
  }

  getTaxDetails = () => {
    const { orderData, deliveryData, customerAddress } = this.state
    if (orderData && orderData.is_custom_tax) {
      if (
        orderData.tax_percentage &&
        parseFloat(orderData.tax_percentage) >= 0
      ) {
        return {
          name: orderData.tax_name || "Tax",
          percentage: orderData.tax_percentage
        }
      }
      return null
    } else {
      if (
        isTaxInclusive(
          orderData.is_custom_tax,
          orderData.is_tax_inclusive,
          deliveryData && deliveryData.toMe
            ? (customerAddress && customerAddress.country) || null
            : (deliveryData && deliveryData.country) || null,
          (orderData.taxes && orderData.taxes.map(t => t.country)) || []
        )
      ) {
        const country =
          deliveryData && deliveryData.toMe
            ? (customerAddress &&
                customerAddress.country &&
                customerAddress.country.value) ||
              null
            : (deliveryData && deliveryData.country.value) || null
        const taxDetails =
          orderData.taxes && orderData.taxes.find(c => c.country === country)
        if (taxDetails) {
          return taxDetails
        }
      }

      return null
    }
  }

  getTaxPercentage = () => {
    const { orderData } = this.state
    if (this.getTaxDetails()) {
      return this.getTaxDetails().percentage
    }
    return orderData.tax_percentage
  }

  getSalesBeforeTax = () => {
    const { orderData, deliveryData, customerAddress } = this.state
    let salesBeforeTax = this.getSubTotal()
    if (
      orderData &&
      isTaxInclusive(
        orderData.is_custom_tax,
        orderData.is_tax_inclusive,
        deliveryData && deliveryData.toMe
          ? (customerAddress && customerAddress.country) || null
          : (deliveryData && deliveryData.country) || null,
        (orderData.taxes && orderData.taxes.map(t => t.country)) || []
      ) &&
      this.getTaxPercentage()
    ) {
      salesBeforeTax =
        this.getSubTotal() / (1 + parseFloat(this.getTaxPercentage()) / 100)
    }

    return salesBeforeTax
  }

  getTax = () => {
    const { orderData, deliveryData, customerAddress } = this.state
    let tax = 0
    if (orderData && this.getTaxPercentage()) {
      const taxPercent = parseFloat(this.getTaxPercentage()) / 100
      let computedSubTotal = this.getSubTotal() - this.getDiscount()
      if (
        isTaxInclusive(
          orderData.is_custom_tax,
          orderData.is_tax_inclusive,
          deliveryData && deliveryData.toMe
            ? (customerAddress && customerAddress.country) || null
            : (deliveryData && deliveryData.country) || null,
          (orderData.taxes && orderData.taxes.map(t => t.country)) || []
        )
      ) {
        computedSubTotal = this.getSalesBeforeTax() - this.getDiscount()
      }
      tax = taxPercent * computedSubTotal
      if (orderData.is_sc_taxable) {
        tax += taxPercent * this.getShippingRate()
      }
    }
    return tax
  }

  getShippingRate = () => {
    const { orderData, deliveryData, customerAddress, isNewOrder } = this.state
    if (isNewOrder && this.checkForActiveCourier() && !deliveryData.courier_id)
      return 0
    if (deliveryData.courier_id) return deliveryData.shippingFee
    const base =
      deliveryData && deliveryData.toMe
        ? (customerAddress &&
            customerAddress.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[customerAddress.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
        : (deliveryData &&
            deliveryData.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[deliveryData.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
    const list = this.getCountryList()
    const value =
      (base === "price" && this.getSubTotal()) || this.getTotalWeight()
    const shippingRate =
      (list && parseFloat(value) >= 0 && getShipping(list, value, base)) || null
    if (deliveryData && deliveryData.preferPickup) {
      return 0
    }
    if (
      orderData &&
      orderData.is_pickup === false &&
      orderData.rate_type !== "weight" &&
      orderData.rate_type !== "price"
    ) {
      if (orderData.shipping_fee) {
        return orderData.shipping_fee
      }
      return 0
    } else {
      if (shippingRate && typeof shippingRate.amount !== "undefined") {
        return shippingRate.amount
      }
      return 0
    }
  }

  getShippingRateId = () => {
    const { orderData, deliveryData, customerAddress } = this.state
    const base =
      deliveryData && deliveryData.toMe
        ? (customerAddress &&
            customerAddress.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[customerAddress.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
        : (deliveryData &&
            deliveryData.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[deliveryData.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
    const list = this.getCountryList()
    const value =
      (base === "price" && this.getSubTotal()) || this.getTotalWeight()
    const shippingRate =
      (list && parseFloat(value) >= 0 && getShipping(list, value, base)) || null
    if (deliveryData && deliveryData.preferPickup) {
      return null
    }
    if (
      orderData &&
      orderData.rate_type === "custom" &&
      orderData.is_pickup === false
    ) {
      if (orderData.shipping_fee) {
        return null
      }
      return null
    } else {
      if (shippingRate && typeof shippingRate.id !== "undefined") {
        return shippingRate.id
      }
      return null
    }
  }

  getActiveCouriers = data => {
    const { customerAddress } = this.state
    const country =
      (customerAddress &&
        customerAddress.country &&
        customerAddress.country.value) ||
      null
    let shippingMethods = []
    let deliveryMethod = []
    if (data) {
      if (
        country &&
        country === "philippines" &&
        data.hasOwnProperty("courier")
      ) {
        deliveryMethod = data.courier.hasOwnProperty("no-country")
          ? data.courier["no-country"]
          : data.courier
      } else {
        deliveryMethod = []
      }
      deliveryMethod.length > 0 &&
        deliveryMethod.map(
          (item, i) =>
            item.is_active &&
            shippingMethods.push({
              value: { name: item.name, id: item.id },
              label:
                item.name === "payo.asia"
                  ? "Payo.Asia (1-3 day shipping)"
                  : item.name === "lalamove"
                    ? "Lalamove"
                    : item.name
            })
        )
    }
    return shippingMethods
  }

  checkForActiveCourier = () => {
    const { orderData } = this.state
    const cours =
      (orderData &&
        orderData.rates &&
        orderData.rates.data &&
        orderData.rates.data.shipping &&
        orderData.rates.data.shipping.courier) ||
      []
    if (cours && cours.length > 0) {
      const activeFound = cours.find(c => c.is_active === true)
      if (activeFound) return true
      return false
    }
    return false
  }

  getDeliveryMethod = () => {
    const { orderData, deliveryData, customerAddress, isNewOrder } = this.state
    const base =
      deliveryData && deliveryData.toMe
        ? (customerAddress &&
            customerAddress.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[customerAddress.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
        : (deliveryData &&
            deliveryData.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[deliveryData.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
    const list = this.getCountryList()
    const value =
      (base === "price" && this.getSubTotal()) || this.getTotalWeight()
    const shippingRate =
      (list && parseFloat(value) >= 0 && getShipping(list, value, base)) || null
    if (deliveryData && deliveryData.preferPickup) {
      return "Pick-up"
    }
    if (isNewOrder && this.checkForActiveCourier() && !deliveryData.courier_id)
      return ""
    if (
      deliveryData &&
      deliveryData.courier_id &&
      deliveryData.courier_id !== null
    ) {
      return deliveryData.method
        ? deliveryData.method.hasOwnProperty("label")
          ? deliveryData.method.label
          : deliveryData.method
        : "Courier"
    }
    if (
      orderData &&
      orderData.rate_type === "custom" &&
      orderData.is_pickup === false
    ) {
      if (orderData.delivery_method) {
        return orderData.delivery_method
      }
      return ""
    } else {
      if (shippingRate && typeof shippingRate.name !== "undefined") {
        return shippingRate.name
      }
      return ""
    }
  }

  getCountryList = () => {
    const { orderData, deliveryData, customerAddress } = this.state
    const base =
      deliveryData && deliveryData.toMe
        ? (customerAddress &&
            customerAddress.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[customerAddress.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
        : (deliveryData &&
            deliveryData.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[deliveryData.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
    let list =
      (base &&
        orderData.rates.data &&
        orderData.rates.data.shipping &&
        orderData.rates.data.shipping[base]) ||
      null
    if (list) {
      list =
        deliveryData && deliveryData.toMe
          ? (customerAddress &&
              customerAddress.country &&
              list[customerAddress.country.value]) ||
            null
          : (deliveryData &&
              deliveryData.country &&
              list[deliveryData.country.value]) ||
            null
    }
    return list
  }

  getAvailableCountries = () => {
    const {
      orderData,
      deliveryData,
      customerAddress,
      isNewOrder,
      payoAsiaId
    } = this.state
    const base =
      deliveryData && deliveryData.toMe
        ? (customerAddress &&
            customerAddress.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[customerAddress.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
        : (deliveryData &&
            deliveryData.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[deliveryData.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
    let list =
      (base &&
        orderData.rates.data &&
        orderData.rates.data.shipping &&
        orderData.rates.data.shipping[base]) ||
      null
    if (deliveryData.courier_id !== payoAsiaId) {
      if (list) {
        return Object.keys(orderData.rates.data.shipping[base])
      }
      if (isNewOrder) {
        return (
          (orderData.rates.data.is_active &&
            Object.keys(orderData.rates.data.is_active)) ||
          null
        )
      }
    } else if (payoAsiaId !== null && deliveryData.courier_id === payoAsiaId) {
      return ["philippines"]
    }
    if (isNewOrder) {
      return (
        (orderData.rates.data.is_active &&
          Object.keys(orderData.rates.data.is_active)) ||
        null
      )
    }
    return null
  }

  isCustomerAddressInRates = () => {
    const { customerAddress, deliveryData, orderData } = this.state
    const country =
      deliveryData && deliveryData.toMe
        ? customerAddress &&
          customerAddress.country &&
          customerAddress.country.value
        : deliveryData.country && deliveryData.country.value
    const base =
      deliveryData && deliveryData.toMe
        ? (customerAddress &&
            customerAddress.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[customerAddress.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
        : (deliveryData &&
            deliveryData.country &&
            orderData &&
            orderData.rates &&
            orderData.rates.data &&
            orderData.rates.data.is_active &&
            orderData.rates.data.is_active[deliveryData.country.value]) ||
          (orderData && orderData.rate_type) ||
          null
    let list =
      (base &&
        orderData.rates.data &&
        orderData.rates.data.shipping &&
        orderData.rates.data.shipping[base]) ||
      null

    if (list && country && list[country]) {
      return true
    }

    return false
  }

  getDiscount = () => {
    const { orderData, deliveryData, customerAddress } = this.state
    if (orderData && orderData.discount_amount) {
      if (
        isTaxInclusive(
          orderData.is_custom_tax,
          orderData.is_tax_inclusive,
          deliveryData && deliveryData.toMe
            ? (customerAddress && customerAddress.country) || null
            : deliveryData && deliveryData.country,
          (orderData.taxes && orderData.taxes.map(t => t.country)) || []
        )
      ) {
        if (!orderData.is_percentage) {
          return (
            orderData.discount_amount /
            (1 + parseFloat(this.getTaxPercentage()) / 100)
          )
        } else {
          return (
            ((parseFloat(orderData.discount_amount) / 100) *
              this.getSubTotal()) /
            (1 + parseFloat(this.getTaxPercentage()) / 100)
          )
        }
      } else {
        if (!orderData.is_percentage) {
          return orderData.discount_amount
        } else {
          return (
            (parseFloat(orderData.discount_amount) / 100) * this.getSubTotal()
          )
        }
      }
    }
    return 0
  }

  getGrandTotal = () => {
    return parseFloat(
      parseFloat(this.getSalesBeforeTax().toFixed(2)) -
        parseFloat(this.getDiscount().toFixed(2)) +
        parseFloat(parseFloat(this.getShippingRate()).toFixed(2) || 0) +
        parseFloat(this.getTax().toFixed(2))
    ).toFixed(2)
  }

  getTotalWeight = () => {
    function convertWeightToG(weight, unit) {
      if (unit === "kg") {
        return parseFloat(weight) * 1000
      }
      return parseFloat(weight)
    }
    return this.state.products.reduce(
      (a, c) =>
        a +
        parseInt(c.quantity) *
          convertWeightToG(c.shipment_weight, c.weight_unit),
      0
    )
  }

  getPayoRate = async () => {
    const {
      customerAddress,
      // orderData,
      // isNewOrder,
      // account_uuid,
      customerData
    } = this.state
    const weightTotal = this.getTotalWeight()
    const payoData = {
      weight: weightTotal || 0,
      province: customerAddress.state.value,
      country: customerAddress.country.value
    }
    API_PUBLIC.defaults.headers.common["account-uuid"] = customerData.account
    try {
      const response = await API_PUBLIC.post(
        `checkout/courier/payo.asia/get_rate`,
        JSON.stringify(payoData)
      )
      console.log("Payo Response: ", response)
      const {
        data: {
          data: { rates },
          handling_fee
        }
      } = response
      const payoCost = rates && rates[0] && rates[0].costSuccess
      this.setState(state => ({
        orderData: {
          ...state.orderData,
          shipping_fee: payoCost + handling_fee
        },
        deliveryData: {
          ...state.deliveryData,
          courier_id: this.state.payoAsiaId,
          courier: payoData,
          misc: payoData,
          shippingFee: payoCost + handling_fee
        }
      }))
    } catch (err) {
      console.log("Payo API Error", err)
    }
  }

  setProductQuantity = (quantity, id) => {
    if (!isNaN(Number(quantity))) {
      const { products } = this.state
      const selected = products.find(p => p.id === id)
      const selectedIndex = products.indexOf(selected)
      const product = Object.assign({}, selected)
      product.quantity = quantity
      const updatedProducts = update(products, {
        [selectedIndex]: { $set: product }
      })
      this.setState(state => ({
        ...state,
        products: updatedProducts
      }))
    }
  }

  showRemoveDialog = (productId, type = "regular") => {
    this.setState(
      state => ({
        ...state,
        selectedProduct: productId,
        selectedProductType: type
      }),
      () => {
        this.setState({ removeDialogShown: true })
      }
    )
  }

  closeRemoveDialog = () => {
    this.setState({ removeDialogShown: false })
  }

  removeProduct = () => {
    const {
      products,
      selectedProduct,
      customProducts,
      selectedProductType
    } = this.state
    if (selectedProductType === "custom") {
      const selected = customProducts.find(p => p.id === selectedProduct)
      const selectedIndex = customProducts.indexOf(selected)
      const updatedProducts = update(customProducts, {
        $splice: [[selectedIndex, 1]]
      })
      this.setState(
        state => ({
          ...state,
          customProducts: updatedProducts
        }),
        () => {
          this.closeRemoveDialog()
        }
      )
    } else {
      const selected = products.find(p => p.id === selectedProduct)
      const selectedIndex = products.indexOf(selected)
      const updatedProducts = update(products, {
        $splice: [[selectedIndex, 1]]
      })
      this.setState(
        state => ({
          ...state,
          products: updatedProducts
        }),
        () => {
          this.closeRemoveDialog()
        }
      )
    }
  }

  finishCart = () => {
    this.setActiveStep("info")
  }

  chooseLogin = method => {
    this.setState(state => ({
      ...state,
      info: { ...state.info, active: method }
    }))
  }

  setCheckoutMethod = method => {
    this.setState(state => ({
      checkoutMethod: method
    }))
  }

  setCustomerData = newCustomerData => {
    this.setState(state => ({
      ...state,
      customerData: Object.assign(state.customerData, newCustomerData)
    }))
  }

  setSteps = step => {
    this.setState(state => ({ ...state, steps: [...state.steps, step] }))
  }

  setCustomerAddress = newCustomerAddress => {
    this.setState({
      customerAddress: newCustomerAddress
      // {
      //   addressOne: newCustomerAddress.addressOne || "",
      //   addressTwo: newCustomerAddress.addressTwo || "",
      //   barangay: newCustomerAddress.barangay || "",
      //   city: newCustomerAddress.city || "",
      //   country: newCustomerAddress.country || "",
      //   state: newCustomerAddress.state || "",
      //   zipcode: newCustomerAddress.zipcode || ""
      // }
    })
  }

  setDeliveryData = deliveryData => {
    this.setState({
      deliveryData: { ...this.state.deliveryData, ...deliveryData }
    })
  }

  setActiveStep = step => {
    this.setState({ activeStep: step })
  }

  toggleCreateAccount = () => {
    this.setState({ createAccount: !this.state.createAccount })
  }

  hasAddress = () => {
    const { orderData } = this.state
    const address =
      (orderData &&
        orderData.customer_info &&
        orderData.customer_info.address) ||
      null
    const addressKeys = [
      "address_line_1",
      "city",
      "country",
      "state",
      "zipcode"
    ]
    const philippineAddressKeys = [
      "address_line_1",
      "barangay",
      "city",
      "country",
      "state",
      "zipcode"
    ]
    let addressBool = true
    if (address && address.country === "philippines") {
      philippineAddressKeys.forEach(key => {
        if (address[key] === "" || address[key] === null) {
          return (addressBool = false)
        } else {
          return (addressBool = true)
        }
      })
    } else if (address) {
      addressKeys.forEach(key => {
        if (address[key] === "" || address[key] === null) {
          return (addressBool = false)
        } else {
          return (addressBool = true)
        }
      })
    }
    return addressBool
  }

  renderActiveStep = () => {
    const {
      products,
      customProducts,
      orderData,
      steps,
      maxQuantities,
      activeStep,
      info,
      createAccount,
      checkoutMethod,
      confirmingOrder,
      canSelectAllCountry
    } = this.state
    switch (activeStep) {
      case "cart":
        return (
          <ShoppingCart
            steps={steps}
            orderData={orderData}
            orderProducts={products}
            customProducts={customProducts}
            maxQuantities={maxQuantities}
            setProductQuantity={this.setProductQuantity}
            closeButtonAction={this.showRemoveDialog}
            proceedToCheckout={this.finishCart}
            setSteps={this.setSteps}
          />
        )
      case "info":
        return (
          <CustomerInfo
            info={info}
            chooseLogin={this.chooseLogin}
            setCustomerData={this.setCustomerData}
            customerData={this.state.customerData}
            setCustomerAddress={this.setCustomerAddress}
            deliveryData={this.state.deliveryData}
            backHandler={this.backHandler}
            setSteps={this.setSteps}
            steps={steps}
            setActiveStep={this.setActiveStep}
            checkoutMethod={this.state.checkoutMethod}
            setCheckoutMethod={this.setCheckoutMethod}
            uuid={this.state.orderData.uuid}
            account_uuid={this.state.orderData.account}
            showAccountRegister={this.showAccountRegister}
            handleForgotPassword={this.handleForgotPassword}
            hideForgotPassword={this.hideForgotPassword}
            handleShowVerifyEmail={this.handleShowVerifyEmail}
            hideVerifyEmail={this.hideVerifyEmail}
            setShowFacebookErrorPopup={this.setShowFacebookErrorPopup}
            showFacebookErrorPopup={this.state.showFacebookErrorPopup}
            setCustomerStatus={this.setCustomerStatus}
            isNewOrder={this.state.isNewOrder}
            newOrderAccountUuid={this.state.account_uuid}
          />
        )
      case "shipping":
        return (
          <ShippingMethod
            customerAddress={this.state.customerAddress}
            customerInfo={this.state.customerData}
            setDeliveryData={this.setDeliveryData}
            setCustomerData={this.setCustomerData}
            setCustomerAddress={this.setCustomerAddress}
            deliveryData={this.state.deliveryData}
            pickupAddressList={this.state.pickupAddressList}
            setActiveStep={this.setActiveStep}
            backHandler={this.backHandler}
            setSteps={this.setSteps}
            steps={steps}
            countryList={this.getAvailableCountries()}
            canSelectAllCountry={canSelectAllCountry}
            isCustomShipping={this.state.orderData.rate_type === "custom"}
            deliveryMethodName={this.getDeliveryMethod()}
            orderData={this.state.orderData}
            activeCouriers={this.getActiveCouriers(
              orderData.rates.data.shipping
            )}
            isNewOrder={this.state.isNewOrder}
            customerData={this.state.customerData}
            products={this.state.products}
            customProducts={this.state.customProducts}
            newOrderAccountUuid={this.state.account_uuid}
          />
        )
      case "payment":
        return (
          <PaymentMethod
            methods={this.state.orderData.payment_gateway}
            setPaymentMethod={this.setPaymentMethod}
            currentMethod={this.state.paymentMethod}
            backHandler={this.backHandler}
            setSteps={this.setSteps}
            steps={steps}
            createAccount={createAccount}
            toggleCreateAccount={this.toggleCreateAccount}
            handleConfirmPaymentMethod={this.handleConfirmPaymentMethod}
            checkoutMethod={checkoutMethod}
            confirmingOrder={confirmingOrder}
            setOnlinePaymentDetails={this.setOnlinePaymentDetails}
            orderData={this.state.orderData}
            grandTotal={this.getGrandTotal()}
            salesBeforeTax={this.getSalesBeforeTax()}
            tax={this.getTax()}
            discountAmount={this.getDiscount()}
            shippingRate={this.getShippingRate()}
            deliveryData={this.state.deliveryData}
            courierPaymentOnly={this.state.courierPaymentOnly}
          />
        )
      case "register":
        return <CreateAccountForm />
      default:
        return (
          <ShoppingCart
            steps={steps}
            orderData={orderData}
            orderProducts={products}
            customProducts={customProducts}
            maxQuantities={maxQuantities}
            setProductQuantity={this.setProductQuantity}
            closeButtonAction={this.showRemoveDialog}
            proceedToCheckout={this.finishCart}
          />
        )
    }
  }

  cancelOrderByUUID = async () => {
    try {
      this.setState({ cancelling: true })
      await API.put(`checkout/${this.props.match.params.order_uuid}/cancel`)
      await this.getOrderByUUID()
      this.setState({ cancelling: false })
    } catch (error) {
      console.log((error && error.response) || error)
      this.setState({ cancelling: false })
    }
  }

  cancelPasswordRequest = async () => {
    const { isNewOrder, orderData } = this.state
    const { location } = this.props
    const parsed = queryString.parse(location.search)
    const token = parsed["token"]
    const uid = parsed["uid"]
    const acc_uuid = orderData.account
    try {
      API.defaults.headers.common["x-access-token"] = token
      const res = await API.put(
        `customers/${isNewOrder ? uid : acc_uuid}/expire_token`
      )
      console.log(res)
    } catch (err) {
      console.log(err)
    }
  }

  getExpirationDays = (start, expiration) => {
    const given = moment(start)
    const current = moment().startOf("day")
    //Difference in number of days
    const diff = moment.duration(given.diff(current)).asDays()
    return Math.ceil(expiration - diff)
  }

  canSelectAllCountry = () => {
    const { orderData } = this.state
    const orderAddress =
      (orderData.order_address &&
        orderData.order_address.delivery_address &&
        orderData.order_address.delivery_address.address &&
        orderData.order_address.delivery_address.address.country &&
        orderData.order_address.delivery_address.address) ||
      (orderData.customer_info && orderData.customer_info.address)
    if (orderAddress && orderAddress.country) {
      return false
    }
    return true
  }

  getOrderByUUID = async () => {
    try {
      const response = await API.get(
        `checkout/${this.props.match.params.order_uuid}`
      )
      const orderData = response.data.order
      const maxQuantities = orderData.products.reduce((obj, p) => {
        obj[p.id] = p.is_limited
          ? p.inventory_quantity > 0
            ? p.inventory_quantity
            : p.quantity
          : Number.MAX_SAFE_INTEGER
        return obj
      }, {})
      const customerInfo = orderData.customer_info
      const customerData = {
        account: orderData.account,
        firstName: customerInfo.firstname,
        lastName: customerInfo.lastname,
        email: customerInfo.email,
        mobile: {
          mobileNumber: customerInfo.mobile || "",
          countryCode: customerInfo.mobile_country_code || ""
        },
        id: customerInfo.id
      }
      //Set customer address
      const orderAddress =
        (orderData.order_address &&
          orderData.order_address.delivery_address &&
          orderData.order_address.delivery_address.address &&
          orderData.order_address.delivery_address.address.country &&
          orderData.order_address.delivery_address.address) ||
        (orderData.customer_info && orderData.customer_info.address)

      const deliveryData = {
        method: orderData.delivery_method,
        shippingFee: orderData.shipping_fee,
        preferPickup:
          orderData.pickup_address.length === 0
            ? false
            : orderData.is_pickup
              ? true
              : false,
        pickUpAddress:
          (orderData.pickup_address &&
            orderData.pickup_address.length > 0 &&
            orderData.pickup_address.find(
              address => address.name === orderData.delivery_method
            ) &&
            orderData.pickup_address.find(
              address => address.name === orderData.delivery_method
            ).id) ||
          (orderData.pickup_address &&
            orderData.pickup_address.length > 0 &&
            orderData.pickup_address[0].id) ||
          null,
        toMe: true,
        courier_id:
          (orderData &&
            orderData.rate_type === "courier" &&
            orderData.is_editable &&
            orderData.rates.data.shipping.courier.find(
              courier => courier.name === orderData.delivery_method
            ).id) ||
          null,
        courier: (orderData && orderData.courier_json) || null,
        misc: (orderData && orderData.misc) || null
      }
      this.setState(
        state => ({
          ...state,
          orderData: orderData,
          products: orderData.products,
          customProducts: orderData.custom_products,
          maxQuantities: maxQuantities,
          customerData: customerData,
          pickupAddressList: orderData.pickup_address,
          deliveryData: deliveryData,
          forConfirmation: !orderData.is_editable,
          daysLeft: this.getExpirationDays(
            orderData.transaction_date,
            orderData.expiration
          ),
          payoAsiaId:
            (orderData &&
              orderData.rates &&
              orderData.rates.data &&
              orderData.rates.data.shipping &&
              orderData.is_editable &&
              orderData.rates.data.shipping.courier &&
              orderData.rates.data.shipping.courier.find(
                courier => courier.name === "payo.asia"
              ) &&
              orderData.rates.data.shipping.courier.find(
                courier => courier.name === "payo.asia"
              ).id) ||
            null,
          customerAddress: {
            ...state.customerAddress,
            country: {
              value: orderAddress.country || "",
              label: orderAddress.country || ""
            },
            addressOne: orderAddress.address_line_1 || "",
            addressTwo: orderAddress.address_line_2 || "",
            barangay: {
              value: orderAddress.barangay || "",
              label: orderAddress.barangay || ""
            },
            city:
              (orderAddress.country === "philippines" && {
                value: orderAddress.city || "",
                label: orderAddress.city || ""
              }) ||
              orderAddress.city ||
              "",
            state: {
              value: orderAddress.province || "",
              label: orderAddress.province || ""
            },
            zipcode: orderAddress.zipcode || ""
          }
        }),
        () => {
          this.setState(state => ({
            ...state,
            canSelectAllCountry: this.canSelectAllCountry()
          }))
        }
      )
      return Promise.resolve()
    } catch (error) {
      console.log(error)
      if (error.response && error.response.data) {
        if (error.response.data.code === "order/checkout/order-not-found") {
          this.setState({ orderNotFound: true })
        } else if (
          error.response.data.code === "order/checkout/order-is-cancelled"
        ) {
          this.setState({
            orderCancelled: "cancelled",
            businessName: error.response.data.data.businessname
          })
        } else if (
          error.response.data.code === "order/checkout/order-is-expired"
        ) {
          this.setState({
            orderCancelled: "expired",
            businessName: error.response.data.data.businessname
          })
        } else {
          this.setState({ orderNotFound: true })
        }
      } else {
        this.setState({ orderNotFound: true })
      }
      return Promise.reject()
    } finally {
      this.setState(state => ({ ...state, fetching: false }))
    }
  }

  isVerifyingEmail = async () => {
    const { location } = this.props
    const params = queryString.parse(location.search)
    return params && params["token"]
  }

  verifyEmail = async (token, uuid) => {
    if (this.isVerifyingEmail()) {
      API.defaults.headers.common["x-access-token"] = token
      try {
        const res = await API.put(`customers/${uuid}/verify_email`)
        if (res.status === 200) {
          this.setActiveStep("info")
          this.chooseLogin("email")
        }
      } catch (err) {
        if (
          err.response.data &&
          err.response.data.message === "EMAIL_IS_VERIFIED!"
        ) {
          this.setActiveStep("info")
          this.chooseLogin("email")
        }
      }
    }
  }

  setOrderNotCreated = () => {
    this.setState(state => ({ ...state, orderNotCreated: true }))
  }

  handleOrderFormSubmit = values => {
    console.log("Values: ", values)
    this.setState(
      state => ({
        ...state,
        fetching: false,
        orderNotCreated: false,
        isNewOrder: true,
        account_uuid: values.info.account.uuid,
        products: values.products.map((p, i) => ({
          ...p,
          images: p.image ? [p.image] : [],
          quantity: values.quantity[i],
          variants: p.variant.split(", "),
          shipment_weight: p.weight
        })),
        maxQuantities: values.products.reduce((obj, p, i) => {
          obj[p.id] = p.is_limited
            ? p.inventory_quantity > 0
              ? p.inventory_quantity
              : values.quantity[i]
            : Number.MAX_SAFE_INTEGER
          return obj
        }, {}),
        defaultCourierId: values.info.rates.data.shipping.courier
          ? values.info.rates.data.shipping.courier[0].id
          : null,
        deliveryData: {
          ...state.deliveryData,
          toMe: true
        },
        payoAsiaId:
          (values.info &&
            values.info.rates &&
            values.info.rates.data &&
            values.info.rates.data.shipping &&
            values.info.rates.data.shipping.courier &&
            values.info.rates.data.shipping.courier.find(
              courier => courier.name === "payo.asia"
            ) &&
            values.info.rates.data.shipping.courier.find(
              courier => courier.name === "payo.asia"
            ).id) ||
          null,
        businessName: values.info.account.businessname,
        orderData: {
          ...state.orderData,
          ...values.info,
          currency: values.info.account.currency,
          is_tax_inclusive: values.info.settings.is_tax_inclusive,
          is_custom_tax: false,
          is_percentage: true,
          is_sc_taxable: values.info.settings.is_sc_taxable,
          seller: {
            ...state.orderData.seller,
            origin_address: {
              ...values.info.address
            },
            first_name: values.info.account.first_name,
            last_name: values.info.account.last_name,
            mobile: {
              countryCode: values.info.account.mobile_country_code,
              mobileNumber: values.info.account.mobile_number
            }
          }
        },
        pickupAddressList: values.info.pickup_address,
        customerData: {
          ...state.customerData,
          account: values.info.account.uuid
        }
      }),
      () => {
        this.setActiveStep("info")
      }
    )
  }

  async componentDidMount() {
    //check if order uuid is present
    if (
      this.props.match.params.order_uuid &&
      parseInt(this.props.match.params.order_uuid, 10) !== -1
    ) {
      await this.getOrderByUUID()
    } else {
      this.setOrderNotCreated()
    }
    //Check if for email verification
    const { location } = this.props
    const { account, mobile } = this.state.customerData
    const params = queryString.parse(location.search)
    const uuid = account || params["uid"]
    const token = params["token"]
    if (token) {
      await this.verifyEmail(token, uuid, mobile)
    }
    // check if token is passed in search
    const parsedString = queryString.parse(this.props.location.search)
    if (this.props.location.search && parsedString["token"]) {
      this.setActiveStep("info")
      this.chooseLogin("email")
      this.cancelPasswordRequest()
    }
    if (this.props.location.search && parsedString["action"] === "login") {
      this.setActiveStep("info")
      this.chooseLogin("email")
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      pickupAddressList,
      deliveryData,
      payoAsiaId,
      products,
      customerAddress
    } = this.state
    if (
      prevState.deliveryData &&
      prevState.deliveryData.pickUpAddress !==
        this.state.deliveryData.pickUpAddress
    ) {
      const selectedPickUp = pickupAddressList.find(
        address => Number(address.id) === Number(deliveryData.pickUpAddress)
      )
      const pickUpCountry =
        (selectedPickUp && selectedPickUp.address.country) || null
      // setSelectedCourier("")
      this.setState(state => ({
        deliveryData: {
          ...state.deliveryData,
          courier_id: null,
          country: {}
        }
      }))
      if (pickUpCountry) {
        this.setState(state => ({
          customerAddress: {
            ...state.customerAddress,
            country: { label: pickUpCountry, value: pickUpCountry }
          }
        }))
      }
    }
    if (
      (prevState.deliveryData &&
        payoAsiaId !== null &&
        prevState.deliveryData.courier_id !== deliveryData.courier_id &&
        deliveryData.courier_id === payoAsiaId) ||
      (payoAsiaId !== null &&
        deliveryData.courier_id === payoAsiaId &&
        (prevState.products !== products ||
          prevState.customerAddress.state.value !==
            customerAddress.state.value))
    ) {
      this.getPayoRate()
    }
    // Check if payo already booked
    const {
      delivery_method,
      tracking_no,
      payment_gateway,
      payment_detail
    } = this.state.orderData
    if (
      prevState.orderData.delivery_method !== delivery_method &&
      delivery_method === "payo.asia" &&
      prevState.orderData.tracking_no !== tracking_no &&
      tracking_no &&
      !payment_detail
    ) {
      const removeCod = [...payment_gateway].filter(
        item => item.payment_type !== "cod"
      )
      this.setActiveStep("payment")
      this.setState(state => ({
        courierPaymentOnly: true,
        steps: ["payment"],
        orderData: { ...state.orderData, payment_gateway: removeCod }
      }))
    }
  }

  setOrderNotCreated = () => {
    this.setState(state => ({ ...state, orderNotCreated: true }))
  }

  render() {
    const {
      products,
      customProducts,
      fetching,
      orderData,
      steps,
      activeStep,
      orderNotFound,
      customerRemarks,
      coupon,
      customerAddress,
      customerData,
      showRegister,
      forConfirmation,
      showForgotPassword,
      orderCancelled,
      businessName,
      daysLeft,
      showVerifyEmail,
      orderNotCreated,
      account_uuid,
      isNewOrder
    } = this.state
    const selected = products.find(p => p.id === this.state.selectedProduct)
    return (
      <div className="DirectCheckout">
        <AdminAlert />
        {orderNotCreated || (isNewOrder && products.length < 1) ? (
          <OrderForm submitOrderForm={this.handleOrderFormSubmit} />
        ) : (
          <>
            {(!orderNotFound &&
              ((!fetching &&
                ((forConfirmation && (
                  <OrderConfirmation
                    orderData={orderData}
                    subTotal={this.getSubTotal()}
                    grandTotal={this.getGrandTotal()}
                    updateOrderData={this.getOrderByUUID}
                    setOnlinePaymentDetails={this.setOnlinePaymentDetails}
                    //for Amounts
                    tax={this.getTax()}
                    daysLeft={daysLeft}
                  />
                )) || (
                  <>
                    {!showVerifyEmail && (
                      <PageTitle
                        businessname={
                          (orderData && orderData.businessname) || businessName
                        }
                      />
                    )}

                    {(orderCancelled && (
                      <Cancelled status={orderCancelled} />
                    )) ||
                      (showRegister && (
                        <CreateAccountForm
                          orderUuid={this.props.match.params.order_uuid}
                          accountUuid={this.state.account_uuid}
                          isNewOrder={this.state.isNewOrder}
                          submitCallback={this.createAccountCallback}
                          backHandler={this.createAccountCancel}
                          uuid={orderData.account}
                          customerData={Object.assign(
                            {},
                            { ...customerData, ...customerAddress }
                          )}
                          paymentMethod={this.state.paymentMethod}
                          // orderUUID={orderData.uuid}
                        />
                      )) ||
                      (showForgotPassword && (
                        <CheckForgotPassword
                          hideForgotPassword={this.hideForgotPassword}
                          uuid={isNewOrder ? account_uuid : orderData.account}
                          orderUuid={orderData.uuid}
                        />
                      )) ||
                      (showVerifyEmail && (
                        <EmailVerification
                          customerData={Object.assign(
                            {},
                            { ...customerData, ...customerAddress }
                          )}
                          businessName={
                            (orderData && orderData.businessname) ||
                            businessName
                          }
                          orderUUID={orderData.uuid}
                          email={this.state.verifyEmail}
                          verifyMobile={this.state.verifyMobile}
                          emailVerificationError={
                            this.state.emailVerificationError
                          }
                          backHandler={this.hideVerifyEmail}
                        />
                      )) || (
                        <>
                          <DirectCheckoutSteps
                            className="content-section"
                            setActiveStep={this.setActiveStep}
                            steps={steps}
                            activeStep={activeStep}
                          />
                          <div
                            className={`checkout-content content-section ${
                              this.state.activeStep
                            }`}
                          >
                            {(products.length + customProducts.length > 0 && (
                              <>
                                <div className="current-step">
                                  {this.renderActiveStep()}
                                </div>
                                <div>
                                  <OrderSummary
                                    products={products}
                                    customProducts={customProducts}
                                    orderData={orderData}
                                    customerAddress={customerAddress}
                                    subTotal={this.getSubTotal()}
                                    grandTotal={this.getGrandTotal()}
                                    customerRemarks={customerRemarks}
                                    handleCustomerRemarksChange={
                                      this.handleCustomerRemarksChange
                                    }
                                    coupon={coupon}
                                    handleCouponChange={this.handleCouponChange}
                                    deliveryData={this.state.deliveryData}
                                    customerInfo={customerData}
                                    totalWeight={this.getTotalWeight()}
                                    //for Amounts
                                    salesBeforeTax={this.getSalesBeforeTax()}
                                    tax={this.getTax()}
                                    taxDetails={this.getTaxDetails()}
                                    shippingRate={this.getShippingRate()}
                                    deliveryMethodName={this.getDeliveryMethod()}
                                    discountAmount={orderData.discount_amount}
                                    isTaxInclusive={isTaxInclusive(
                                      orderData.is_custom_tax,
                                      orderData.is_tax_inclusive,
                                      this.state.deliveryData &&
                                      this.state.deliveryData.toMe
                                        ? (customerAddress &&
                                            customerAddress.country) ||
                                          null
                                        : (this.state.deliveryData &&
                                            this.state.deliveryData.country) ||
                                          null,
                                      (orderData &&
                                        orderData.taxes &&
                                        orderData.taxes.map(t => t.country)) ||
                                        []
                                    )}
                                    isNewOrder={this.state.isNewOrder}
                                  />
                                </div>
                              </>
                            )) || (
                              <CancelOrder
                                cancelOrder={
                                  this.state.cancelling
                                    ? () => {}
                                    : this.cancelOrderByUUID
                                }
                                cancelling={this.state.cancelling}
                              />
                            )}
                          </div>
                        </>
                      )}
                    <CheckoutFooter
                      businessName={
                        (orderData && orderData.businessname) || businessName
                      }
                    />
                    {this.state.removeDialogShown && (
                      <DialogBox
                        primaryAction={this.removeProduct}
                        primaryActionLabel="Remove"
                        secondaryAction={this.closeRemoveDialog}
                        secondaryActionLabel="Cancel"
                        close={this.closeRemoveDialog}
                        closeLabel="Cancel"
                        title="Remove Product"
                      >
                        <p>
                          Are you sure you want to remove
                          {` ${(selected && selected.name) || "product"}`}?
                        </p>
                      </DialogBox>
                    )}
                  </>
                ))) || <Loader />)) || <NotFound />}
          </>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  }
})

export default connect(
  null,
  mapDispatchToProps
)(DirectCheckout)
